<template>
    <div class="section">
        <div v-if="wave" class="wave" :class="wave"></div>
        <div :id="pin" class="content" :class="color">
            <div class="wrapper" :class="flex_direction">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Section',
    props: ['pin', 'color', 'wave', 'flex_direction']
}
</script>